import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { assets, contact, systems } from "../../mock";
import { HeroCarousel } from "./HeroCarousel";

const scrollTo = (sel) => document.querySelector(sel)?.scrollIntoView({ behavior: "smooth" });

export const Hero = () => {
  const navigate = useNavigate();
  return (
  <section id="home" className="relative overflow-hidden" data-testid="hero-section">
    <div className="absolute inset-0 bg-cover bg-center scale-105" style={{ backgroundImage: `url(${assets.heroBg})` }} />
    <div className="absolute inset-0 bg-gradient-to-r from-[#0b1220]/85 via-[#1A237E]/55 to-black/20" />
    <div className="relative max-w-[1224px] mx-auto px-4 lg:px-5 py-8 lg:py-0 lg:h-[280px] grid lg:grid-cols-2 items-center gap-6">
      <div className="es-fade-up">
        <span className="inline-flex items-center gap-2 h-[26px] px-3 rounded-full bg-white/10 border border-white/20 backdrop-blur-md text-white/90 text-[11px] uppercase tracking-[0.18em]"><span className="w-1.5 h-1.5 rounded-full bg-[#CF1072] animate-pulse" />Per ogni attività</span>
        <h1 className="text-white font-bold text-[36px] sm:text-[56px] lg:text-[68px] leading-[1.02] tracking-[-0.02em] sm:whitespace-nowrap mt-3" data-testid="hero-title">Soluzioni Gestionali</h1>
        <p className="text-white/85 text-[15px] leading-[1.5] mt-2 max-w-[420px]">Registratori telematici, PC POS, casse automatiche e software: vendita, noleggio e leasing operativo con assistenza dedicata.</p>
        <div className="flex items-center gap-3 mt-5">
          <button onClick={() => navigate("/negozio")} className="es-btn-primary px-7 h-[42px] text-[14px] gap-2" data-testid="hero-scopri-btn">Scopri i prodotti <ArrowRight className="w-4 h-4" /></button>
          <a href={`mailto:${contact.emailAssist}`} className="inline-flex items-center h-[42px] px-6 rounded-full border border-white/70 text-white text-[14px] hover:bg-white hover:text-[#1A237E] transition-colors duration-300" data-testid="hero-contattaci-btn">Contattaci</a>
        </div>
      </div>
      <div className="relative h-[200px] lg:h-full es-fade-up" style={{ animationDelay: "150ms" }}>
        <div className="absolute left-[28%] top-1/2 -translate-y-1/2 w-[260px] h-[260px] rounded-full bg-[#CF1072]/25 blur-3xl" />
        <HeroCarousel />
      </div>
    </div>
  </section>
  );
};

export const Systems = () => {
  const navigate = useNavigate();
  const act = (t) => (t.startsWith("/") ? navigate(t) : scrollTo(t));
  return (
  <section id="soluzioni" className="relative bg-gradient-to-b from-[#e8ebf2] to-[#d5dae4] py-8" data-testid="systems-section">
    <div className="max-w-[1224px] mx-auto px-4 lg:px-5">
      <div className="flex flex-wrap items-end justify-between gap-2 mb-5 es-reveal">
        <div>
          <p className="text-[#CF1072] text-[12px] uppercase tracking-[0.2em]">Hardware & Software</p>
          <h2 className="text-[#1d1e20] font-bold text-[28px] lg:text-[32px] leading-tight">Sistemi Gestionali</h2>
        </div>
        <button onClick={() => navigate("/negozio")} className="text-[14px] text-[#CF1072] font-bold inline-flex items-center gap-1 hover:gap-2 transition-[gap] duration-200" data-testid="systems-all">Tutte le soluzioni <ArrowRight className="w-4 h-4" /></button>
      </div>
      <div className="grid md:grid-cols-3 gap-5">
        {systems.map((s, i) => (
          <div key={s.title} onClick={() => act(s.target)} className="group cursor-pointer bg-white/80 backdrop-blur-md border border-white rounded-2xl p-3 flex gap-4 items-center hover:bg-white hover:shadow-xl hover:-translate-y-1 transition-[transform,box-shadow,background-color] duration-300 es-reveal" style={{ transitionDelay: `${i * 120}ms` }} data-testid={`system-card-${i}`}>
            <div className="overflow-hidden rounded-xl w-[130px] h-[150px] shrink-0 bg-[#f4f5fb]">
              <img src={s.image} alt={s.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
            </div>
            <div className="min-w-0">
              <h3 className="text-[#1d1e20] font-bold text-[17px] leading-tight group-hover:text-[#CF1072] transition-colors duration-200">{s.title}</h3>
              <p className="text-[#56585e] text-[13px] leading-[1.45] mt-1.5">{s.text}</p>
              <button onClick={(e) => { e.stopPropagation(); act(s.target); }} className="es-btn-primary h-[34px] px-4 text-[13px] mt-3 gap-1.5" data-testid={`system-cta-${i}`}>{s.cta} <ArrowRight className="w-3.5 h-3.5" /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
};
